<template>
  <div>
    <el-select v-if="!editpage" v-model="collection" filterable  @change="setcollection">
      <el-option
        v-for="x in cat"
        :key="x.value"
        :value="x.value"
        :label="x.label"
        placeholder="请选择数据库"
      ></el-option>
    </el-select>
    <br />
    <p v-if="dbfields">表格读取入数据库的field如下</p>
    <span>{{dbfields}}</span>
    <!-- <span v-for="x in dbfields" :key="x">{{x+";"}}</span> -->
    <br />
    <el-upload
      drag
      :on-change="handlechange"
      :file-list="filelist"
      :auto-upload="false"
      :multiple="false"
      action
    >
      <i class="el-icon-upload"></i>
      <div style="color:red;" slot="tip">
        <p>数据从excel的"Sheet1"工作表导入</p>
        <p>"Sheet1"工作表不能有合并单元格</p>
        <p>excel表格后缀名需为xlsx</p>
        <p>数据读取从第二行开始</p>
      </div>
    </el-upload>

    <!-- <el-input-number v-if="filelist.length>0" v-model="torow"></el-input-number> -->
    <el-button type="primary" style="width:50%" v-if="filelist.length>0" @click="submit">上传</el-button>
  </div>
</template>

<script>
// import { fields } from "../presentation/vuetablefields";
export default {
  props: ["editpage"],
  mounted() {
    //用于初始化，该初始化用于editpage上传时用
    if (this.editpage) {
      this.dbfields = JSON.stringify(
        this.$store.state.currentheader.map(obj => {
          return obj.title;
        })
      );
      // this.formdata.append("collection", this.$store.state.collection.value);
    }
  },
  data() {
    return {
      filelist: [],
      formdata: new FormData(),
      collection: this.editpage ? this.$store.state.collection.value : "",
      //cat:fields["collections"],
      // torow: 2,
      dbfields: this.editpage ? this.$store.state.currentheader : null
    };
  },

  computed: {
    cat() {
      return this.$store.state.collections
      // return this.$store.state.collections.filter(function(obj) {
      //   return !obj.value.includes("tempexcel");
      // });
    }
  },

  methods: {
    handlechange(file, filelist) {
      let filetype = file.name.slice(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (filetype != "xlsx") {
        this.$message("文件格式必须为xlsx");
        return false;
      }
      this.filelist = filelist.slice(-1); //只允许上传一个
      this.formdata.append("excel", file.raw);
      // fetch(file.url)
      //   .then(res => res.blob())
      //   .then(blob => {
      //     this.formdata.append("excel", blob);
      //   });
    },

    setcollection(val) {
      this.formdata.delete("collection");
      this.formdata.append("collection", val);
      //获取fields
      this.$axios.post(url + "excelfields", { collection: val }).then(res => {
        //console.log(res.data)
        //this.dbfields=JSON.stringify(res.data)
        this.dbfields = JSON.stringify(
          res.data.map(obj => {
            return obj.title;
          })
        );
      });
    },

    submit() {
      if (this.collection === "") {
        this.$message("你还未选择数据库");
        return;
      }


      this.$prompt("请输入验证码", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.formdata.set("uploadcode", value)
        this.formdata.append("collection", this.$store.state.collection.value);
        
        this.$axios({
        method: "post",
        url: url + "updatedb",
        data: this.formdata,
        config: { headers: { "Content-Type": "multipart/form-data" } }
      }).then(res => {
        if(res.data=="failed"){
          this.$message("上传失败，请确认验证码正确");
        }
        else{
          this.$message("上传成功");
        this.filelist = [];
        this.formdata = new FormData();
        }

      });

      })
      // this.formdata.append("torow", this.torow);


    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/exceltodb/existingdb.vue